import { FC } from "react";

import { translation as t } from "../utils/translation";
import { IMAGES } from "../assets";
 
const Loader: FC = () => {
  return (
    <div className="flex justify-center items-center p-[100px]">
      <img
        src={IMAGES.LOADER}
        alt={t.ACCESSIBILITY.LOADING} 
        title={t.ACCESSIBILITY.LOADING}
      />
    </div>
  );
};

export default Loader;
